import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenClose, PopupBaseComponent } from '@app/shared/popup';
import { PopupMobileAppInfoService } from './popup-mobile-app-info.service';

@Component({
    selector: 'app-popup-mobile-app-info',
    templateUrl: './popup-mobile-app-info.component.html',
    styleUrls: ['./popup-mobile-app-info.component.scss'],
    animations: [OpenClose],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PopupMobileAppInfoComponent extends PopupBaseComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly popupMobileAppInfoService = inject(PopupMobileAppInfoService);
    private readonly domSanitizer = inject(DomSanitizer);

    linkFirstPart = 'https://socialtalentapp.page.link/?link=';
    linkLastPart = '&apn=com.socialtalent.perform&isi=1383707780&ibi=gat.SocialTalent';

    ngOnInit(): void {
        this.popupMobileAppInfoService.canBeShown = false;
        this.popupMobileAppInfoService.wasShown = true;
    }

    get mobileStoreAppLink() {
        let link = 'https://app.socialtalent.com';
        let router = this.router.url;
        if (router.includes('returnUrl')) {
            const param = this.route.snapshot.queryParamMap.get('returnUrl');
            router = param.split('|')[0];
        }
        if (router.includes('/explore/my-learning/recommended')) {
            router = '/explore/my-learning/recommended';
            link += router;
            return (link = this.linkFirstPart + link + this.linkLastPart);
        }
        if (router.includes('/episode')) {
            link += router;
            return (link = this.linkFirstPart + link + this.linkLastPart);
        }
        if (router.includes('/manager/analysis')) {
            link += '/login';
            link = this.linkFirstPart + link + this.linkLastPart;
            return link;
        } else {
            link += router;
            link = this.linkFirstPart + link + this.linkLastPart;
            return link;
        }
    }

    get openMobileAppLink() {
        const url = 'stapp://openApp';
        return this.domSanitizer.bypassSecurityTrustUrl(url);
    }

    closePopup(message: string): void {
        localStorage.setItem('dontShowPopupMobileApp', '');
        this.close(message);
    }
}
